import { createFileRoute } from '@tanstack/react-router'

import PublicSites from 'pages/PublicSites'

export const Route = createFileRoute('/public/sites/')({
  component: PublicSites,
})
